// Front-end Sentry init.
//
// Static `import * as Sentry` was pulling ~518 KB of @sentry/* into every
// page bundle (app.js) even when GATSBY_SENTRY_DSN was unset. Now this file
// only exports the init function; gatsby-browser.js calls it via dynamic
// import inside onClientEntry so the Sentry SDK is only fetched when a DSN
// is actually configured.

const PII_KEYS = [
  'ssn',
  'dateOfBirth',
  'annualIncome',
  'password',
  'confirmPassword',
  'token',
  'jwt',
  'creditScore',
  'authorization',
  'cookie',
];

function scrubPII(obj, seen) {
  if (!obj || typeof obj !== 'object') return;
  seen = seen || new WeakSet();
  if (seen.has(obj)) return;
  seen.add(obj);
  for (const k of Object.keys(obj)) {
    const lower = k.toLowerCase();
    if (PII_KEYS.includes(k) || PII_KEYS.includes(lower)) {
      obj[k] = '[Filtered]';
    } else if (obj[k] && typeof obj[k] === 'object') {
      scrubPII(obj[k], seen);
    }
  }
}

export async function initSentry() {
  if (!process.env.GATSBY_SENTRY_DSN) return;
  const Sentry = await import('@sentry/gatsby');
  Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN,
    environment: process.env.GATSBY_SENTRY_ENV || 'development',
    tracesSampleRate: Number(
      process.env.GATSBY_SENTRY_TRACES_SAMPLE_RATE || '0.1'
    ),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      scrubPII(event);
      return event;
    },
    beforeBreadcrumb(crumb) {
      if (crumb && crumb.data) scrubPII(crumb.data);
      return crumb;
    },
  });
}
